// Savoria — Restaurant
export const META = { brand: 'Savoria', tag: 'Trattoria · Maison · Aix', est: '1987' };
export const ROUTES = [
  { id: 'home', label: 'Maison' },
  { id: 'carte', label: 'La Carte' },
  { id: 'cuisine', label: 'La Cuisine' },
  { id: 'reserver', label: 'Réserver' },
];
export const SPECIALS = [
  { day: 'Mardi', dish: 'Cèpes du Ventoux, beurre fumé, jaune coulant', price: '38' },
  { day: 'Mercredi', dish: 'Loup de ligne, fenouil sauvage, citron de Menton', price: '52' },
  { day: 'Jeudi', dish: 'Pintade fermière, sauge, polenta crémeuse', price: '46' },
];
export const MENU = [
  { course: 'Pour commencer', items: [
    { t: 'Burrata, courgettes-trompette, basilic du jardin', p: '24', src: 'Caprino di Gioia, Pouilles', n: 'V' },
    { t: 'Carpaccio de bœuf, cèpes, parmesan 24 mois', p: '28', src: 'Charolais, Bourgogne', n: '' },
    { t: 'Vitello tonnato, câpres de Pantelleria, citron confit', p: '26', src: 'Veau de Corrèze', n: '' },
  ]},
  { course: 'Pâtes maison', items: [
    { t: 'Tagliatelle, ragoût d’agneau, romarin', p: '32', src: 'Œufs de Provins · agneau du Lozère', n: '' },
    { t: 'Risotto Carnaroli, safran de l’Hérault', p: '36', src: 'Acquerello vieilli 7 ans', n: 'V' },
    { t: 'Linguine, palourdes, ail nouveau, persil plat', p: '34', src: 'Palourdes du Bassin d’Arcachon', n: '' },
  ]},
  { course: 'Plats', items: [
    { t: 'Bar de ligne en croûte de sel, fenouil rôti', p: '52', src: 'Pêche d’Yves Gladines, Sète', n: '' },
    { t: 'Côte de bœuf maturée 50 jours, frites maison', p: '58', src: 'Salers maturé chez nous', n: '· 2 pers.' },
    { t: 'Magret de canard, cerises, navets glacés', p: '38', src: 'Canard du Sud-Ouest', n: '' },
  ]},
  { course: 'Douceurs', items: [
    { t: 'Tiramisu maison, café-vergé, cacao Valrhona', p: '14', src: '', n: 'V' },
    { t: 'Tarte fine aux figues de Solliès, glace au lait', p: '16', src: 'Figue Bourjasotte', n: 'V' },
    { t: 'Plateau de fromages affinés', p: '22', src: '5 fromages, sélection Hervé Mons', n: 'V' },
  ]},
];
export const HOURS = [
  ['Mardi — Jeudi', '12:00 — 14:00 · 19:30 — 22:00'],
  ['Vendredi & Samedi', '12:00 — 14:30 · 19:00 — 22:30'],
  ['Dimanche', '12:00 — 15:00 (déjeuner uniquement)'],
  ['Lundi', 'Fermé'],
];
